import { render, staticRenderFns } from "./StartScreen.vue?vue&type=template&id=3d5bd332"
import script from "./StartScreen.vue?vue&type=script&lang=ts"
export * from "./StartScreen.vue?vue&type=script&lang=ts"
import style0 from "./StartScreen.vue?vue&type=style&index=0&id=3d5bd332&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
